import { render, staticRenderFns } from "./NewOrderGroupHeadline.vue?vue&type=template&id=2b1c34ee&scoped=true"
import script from "./NewOrderGroupHeadline.vue?vue&type=script&lang=js"
export * from "./NewOrderGroupHeadline.vue?vue&type=script&lang=js"
import style0 from "./NewOrderGroupHeadline.vue?vue&type=style&index=0&id=2b1c34ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c34ee",
  null
  
)

export default component.exports